// extracted by css-extract-rspack-plugin
export default {"branchDropdown":"p7GFtdfDsFc1kPdc","dropdownMenu":"Dh92Dcx1n0JnvZjs","dropdownButton":"Om7mQ0fK6E0WYI4D"};